import { Grid, Typography } from '@mui/material';
import { useQuery } from 'react-query';
import * as assetApi from '../../api/app/assetApi';
import * as monitoredCounterApi from '../../api/app/monitoredCounterApi';
import * as monitoredCounterScrapApi from '../../api/app/monitoredCounterScrapApi';
import * as monitoredCycleTimeApi from '../../api/app/monitoredCycleTimeApi';
import * as monitoredProcessDataApi from '../../api/app/monitoredProcessDataApi';
import * as monitoredStateApi from '../../api/app/monitoredStateApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { PageContent } from '../../components/core/PageContent/PageContent';
import { useTranslation } from '../../contexts/translation';
import { HomePageBlock } from './HomePageBlock';

export function HomePage() {
  const { t } = useTranslation();
  const {
    data: assetCount,
    isLoading: assetIsLoading,
    isError: assetIsError,
  } = useQuery(['assetCount'], () => assetApi.getCount(false));

  const {
    data: assetCountTopOnly,
    isLoading: assetTopOnlyIsLoading,
    isError: assetTopOnlyIsError,
  } = useQuery(['assetCountTop'], () => assetApi.getCount(true));

  const {
    data: monitoredCounterCount,
    isLoading: monitoredCounterIsLoading,
    isError: monitoredCounterIsError,
  } = useQuery(['monitoredCounterCount'], () => monitoredCounterApi.getCount());

  const {
    data: monitoredCounterScrapCount,
    isLoading: monitoredCounterScrapIsLoading,
    isError: monitoredCounterScrapIsError,
  } = useQuery(['monitoredCounterScrapCount'], () => monitoredCounterScrapApi.getCount());

  const {
    data: monitoredCycleTimeCount,
    isLoading: monitoredCycleTimeIsLoading,
    isError: monitoredCycleTimeIsError,
  } = useQuery(['monitoredCycleTimeCount'], () => monitoredCycleTimeApi.getCount());

  const {
    data: monitoredProcessDataCount,
    isLoading: monitoredProcessDataIsLoading,
    isError: monitoredProcessDataIsError,
  } = useQuery(['monitoredProcessDataCount'], () => monitoredProcessDataApi.getCount());

  const {
    data: monitoredStateCount,
    isLoading: monitoredStateIsLoading,
    isError: monitoredStateIsError,
  } = useQuery(['monitoredStateCount'], () => monitoredStateApi.getCount());

  if (
    assetIsError ||
    assetTopOnlyIsError ||
    monitoredCounterIsError ||
    monitoredCounterScrapIsError ||
    monitoredCycleTimeIsError ||
    monitoredProcessDataIsError ||
    monitoredStateIsError
  )
    return <ApiError />;
  if (
    assetIsLoading ||
    assetTopOnlyIsLoading ||
    monitoredCounterIsLoading ||
    monitoredCounterScrapIsLoading ||
    monitoredCycleTimeIsLoading ||
    monitoredProcessDataIsLoading ||
    monitoredStateIsLoading ||
    assetCount === undefined ||
    assetCountTopOnly === undefined ||
    monitoredCounterCount === undefined ||
    monitoredCounterScrapCount === undefined ||
    monitoredCycleTimeCount === undefined ||
    monitoredProcessDataCount === undefined ||
    monitoredStateCount === undefined
  )
    return <Loader />;
  return (
    <>
      <PageContent>
        <Typography variant={'h4'} align="center">
          {t('page.home.main-headline')}
        </Typography>
        <Grid container spacing={3} mt={5} mb={3}>
          <HomePageBlock title={t('page.home.box-headline-1')} value={assetCount} />
          <HomePageBlock title={t('page.home.box-headline-2')} value={assetCountTopOnly} />
        </Grid>
        <Grid container spacing={3}>
          <HomePageBlock title={t('page.home.box-headline-3')} value={monitoredCounterCount} />
          <HomePageBlock title={t('page.home.box-headline-4')} value={monitoredCounterScrapCount} />
          <HomePageBlock title={t('page.home.box-headline-5')} value={monitoredCycleTimeCount} />
          <HomePageBlock title={t('page.home.box-headline-6')} value={monitoredProcessDataCount} />
          <HomePageBlock title={t('page.home.box-headline-7')} value={monitoredStateCount} />
        </Grid>
      </PageContent>
    </>
  );
}
